module.exports = __webpack_public_path__ + "files/f7f4031ec8678b914ab1dd6a3cf7e443.png";